import React, {useEffect, useState} from 'react'

import styles from './ShowNotifyModal.module.scss'

interface FooterButton {
  text: string
  className: string
  callback: {
    type: 'postMessage' | 'redirect' | 'cancel'
    data?: any
    target?: string
  }
}

interface NotifyData {
  title?: string
  content?: string
  footer?: {
    button: FooterButton[]
  }
}

const ShowNotifyModal: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [title, setTitle] = useState<string | null>(null)
  const [content, setContent] = useState<string | null>(null)
  const [footerButtons, setFooterButtons] = useState<FooterButton[]>([])
  const mData = new Map<number, any>()

  const closeModal = () => setIsVisible(false)

  const handlePostMessage = (index: number) => {
    const item = mData.get(index)
    if (item) {
      window.postMessage(item, location.origin)
    }
    closeModal()
  }

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const origin = location.origin

      if (
        event.origin === origin &&
        typeof event.data === 'string' &&
        event.data.includes('ShowNotify')
      ) {
        const data: NotifyData = JSON.parse(event.data)

        setTitle(data.title || null)
        setContent(data.content || null)
        setFooterButtons(data.footer?.button || [])
        console.log('footerButtons1: ', footerButtons)
        setIsVisible(true)
        console.log('title: ' + data.title)
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const origin = location.origin

      if (
        event.origin === origin &&
        typeof event.data === 'string' &&
        event.data.includes('ShowNotify')
      ) {
        const data: NotifyData = JSON.parse(event.data)

        setTitle(data.title || null)
        setContent(data.content || null)
        setFooterButtons(data.footer?.button || [])
        setIsVisible(true)
        console.log('title: ' + data.title)
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  useEffect(() => {
    console.log('footerButtons: ', footerButtons)
  }, [footerButtons])

  return (
    <div
      className={`${styles.modal} ${isVisible ? styles.show : styles.hidden}`}
      id="showNotifyPopup"
    >
      <div className={styles.modalContent}>
        {title && (
          <div className={styles.modalHeader}>
            <span
              className={styles.closeModal}
              onClick={closeModal}
              role="button"
              aria-label="Close modal"
            >
              &times;
            </span>
            <h4 className={styles.headerTitle}>{title}</h4>
          </div>
        )}
        <div className={styles.modalBody}>
          <div dangerouslySetInnerHTML={{__html: content || ''}}></div>
        </div>
        {footerButtons.length > 0 && (
          <div
            className={`${styles.modalFooter} ${
              footerButtons.length ? '' : styles.hidden
            }`}
          >
            {footerButtons.map((button, index) => {
              {
                console.log('first button: ', button)
              }
              if (button.callback.type === 'postMessage') {
                mData.set(index, button.callback.data)
                return (
                  <button
                    key={index}
                    className={`${styles.btn} ${styles['btn-cancel']}`}
                    onClick={() => handlePostMessage(index)}
                  >
                    {button.text}
                  </button>
                )
              } else if (button.callback.type === 'redirect') {
                return (
                  <a
                    key={index}
                    className={`${styles.btn} ${styles[button.className]}`}
                    target={button.callback.target || '_self'}
                    href={button.callback.data}
                    onClick={closeModal}
                  >
                    {button.text}
                  </a>
                )
              } else if (button.callback.type === 'cancel') {
                return (
                  <button
                    key={index}
                    className={`${styles.btn} ${styles['btn-primary']}`}
                    onClick={closeModal}
                  >
                    {button.text}
                  </button>
                )
              }
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export default ShowNotifyModal
